import { Typography } from "@mui/material";

import { useLearning } from "../hooks/useLearning";
import { CourseLocation } from "./CourseLocation";
import { CourseMedia } from "./CourseMedia";

export function ServiceInformation() {
	const { course } = useLearning();

	if (!course) {
		return;
	}

	return (
		<div className="service-information-container item-separator-big">
			<CourseMedia />
			<Typography
				className="normal-text item-separator-small"
				textAlign="justify"
				whiteSpace="break-spaces">
				{course.description}
			</Typography>
			<CourseLocation />
		</div>
	);
}
